<template>
    <div class="container mb-3 mt-3 card-body">

        <h3 class="mb-4 text-primary font-weight-bold"><i class="fa fa-comment-alt" aria-hidden="true"></i>
            ตั้งค่าข้อความตอบกลับ
        </h3>

        <div class="form-group">
            <label class="font-weight-bold">ประเภท</label>
            <div> {{data.name}}</div>

        </div>

        <div class="form-group">
            <label class="font-weight-bold">ข้อความตอบกลับ</label>

            <textarea class="form-control mb-2"
                      placeholder="ข้อความตอบกลับ"
                      v-model="form.value">
            </textarea>

            <error-message :msg="errorMessage.value"></error-message>


        </div>


        <div>
            <base-button type="secondary" @click="close">
                ยกเลิก
            </base-button>

            <base-button type="primary" @click="save">
                ยืนยันข้อมูล
            </base-button>
        </div>
    </div>

</template>
<script>

    import validate from 'validate.js';
    import ErrorMessage from "./ErrorMessage";
    import store from '../store';
    import {mapState} from 'vuex';
    import {
        UPDATE_SETTING
    } from "../store/actions.type";
    import Swal from 'sweetalert2/src/sweetalert2.js'


    export default {
        name: 'editmessage',
        components: {ErrorMessage},
        computed: {
            ...mapState({}),
        },
        props: {
            data: Object
        },
        data() {
            return {
                form: {},
                images: [],
                errorMessage: {},
                isLoading: false,
            }
        },

        created() {
            // if has data is edit mode
            if (this.data) {
                this.form = JSON.parse(JSON.stringify(this.data));
            }
        },

        methods: {
            close() {
                this.$emit("closePanel", {});
            },

            async save() {
                let errorMessage = this.validateForm(this.form);

                if (errorMessage) {
                    return this.errorMessage = errorMessage;
                } else {
                    this.errorMessage = {};
                }

                if (this.isLoading) return;
                this.isLoading = true;

                if (this.form.id) {
                    // update qr
                    await store.dispatch(UPDATE_SETTING, this.form);

                    Swal.fire(
                        {
                            text: `บันทึกข้อมูลสำเร็จ`,
                            type: 'success',
                            customClass: {
                                confirmButton: 'btn-primary'
                            }
                        });
                }

                this.isLoading = false;

                // close dialog
                this.$emit("closePanel", {confirm: true});
            },

            validateForm(data) {
                let validateRule = null;
                let errMessageList = null;

                validateRule = {
                    value: {
                        presence: {
                            allowEmpty: false,
                            message: "^โปรดระบุ ข้อความตอบกลับ"
                        },
                    }
                };

                errMessageList = validate(
                    {
                        value: data.value
                    }, validateRule);

                if (errMessageList) {
                    const error = {};
                    for (const [key, value] of Object.entries(errMessageList)) {
                        error[key] = value[0];
                    }
                    return error;
                } else {
                    return false;
                }

            },
        },
    };
</script>


<style lang="scss" scoped>

</style>
